"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoneVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class NoneVfxStepArgs {
    constructor() {
        this.__typeName = "None";
        this.id = (0, uuid_1.v4)();
    }
}
exports.NoneVfxStepArgs = NoneVfxStepArgs;
